
import store from '@/store';
import { IJobs, Job, JobsInLocation } from '@/models/main';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState(['jobBfixData', 'storeDrivers', 'storeShowBfixCategory']),
  },
})
export default class DriverSelect extends Vue {
  private drivers: Array<string | number> = [];
  private driversSelected: Array<string | number> = [];
  private storeDrivers!: Array<string | number>;
  private storeShowBfixCategory!: string;
  private jobBfixData!: IJobs;
  private updateDrivers() {
    this.drivers = [];
    let locations: Job[] = [];
    if (this.storeShowBfixCategory === 'all') {
      locations = this.jobBfixData.all;
    }
    if (this.storeShowBfixCategory === 'unallocated') {
      locations = this.jobBfixData.unallocated;
    }
    if (this.storeShowBfixCategory === 'progress') {
      locations = this.jobBfixData.in_progress;
    }
    if (this.storeShowBfixCategory === 'completed') {
      locations = this.jobBfixData.completed;
    }
    if (this.storeShowBfixCategory === 'cancelled') {
      locations = this.jobBfixData.cancelled;
    }
    locations.forEach(location => {
      Object.values(location).forEach((locationJobs: JobsInLocation) => {
        Object.values(locationJobs).forEach((job: Job) => {
          if (job.driver1 && job.driver1 !== 'NOT ALLOCATED' && this.drivers.indexOf(job.driver1) === -1) {
            this.drivers.push(job.driver1);
          }
          if (job.driver2 && job.driver2 !== 'NOT ALLOCATED' && this.drivers.indexOf(job.driver2) === -1) {
            this.drivers.push(job.driver2);
          }
        });
      });
    });
    this.drivers.sort((a: string | number, b: string | number): number => +a - +b);
  }
  @Watch('driversSelected')
  private changeDrivers() {
    store.dispatch('setDrivers', this.driversSelected);
  }
  @Watch('jobBfixData')
  private changeJobs() {
    this.updateDrivers();
  }
  @Watch('storeShowBfixCategory')
  private changeCategory() {
    this.updateDrivers();
  }
  private mounted() {
    this.updateDrivers();
    this.driversSelected = this.storeDrivers;
  }
}
